import React, { useState, useEffect } from "react";
import "../../components/Supplier/Supplier.css";
import axios from "axios";

const Supplier = ({tokenStorage,openProfile,setOpenProfile,selectedSupplierId}) => {

  const baseAPI = process.env.REACT_APP_API_URL;

  const [isEmailValid, setIsEmailValid] = useState(true);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);
    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETSupplier?SupplierID=` +
          selectedSupplierId,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [firstItem, setFirstItem] = useState({
    supplierid: selectedSupplierId,
    suppliername: "",
    emailid: "",
    phonenumber: "",
    address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "emailid") {
      // Use a simple check for email validity
      const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      setIsEmailValid(isValid);
    }
      // For other fields, update the state directly
      setFirstItem((prevItem) => ({
        ...prevItem,
        [name]: value,
      }));
    
    
    
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setFirstItem({
      supplierid: selectedSupplierId,
    });
    if (!isEmailValid) {
      // Optionally, you can display an error message or handle it in any way you prefer.
      console.error("Invalid email address");
      return;
    }
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddSupplierDetail`,
        firstItem, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      // Optionally, reset the form
      setFirstItem({
        suppliername: "",
        emailid: "",
        phonenumber: "",
        address: "",
      });
      tokenStorage();
      setOpenProfile (!openProfile); 
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="supplierDetail">
        <form className="supplier-form">
        <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Supplier Name</td>
              <td>Email Id</td>
              <td>Phone No.</td>
            </tr>

            <tr>
              <td>
                <input name="suppliername" value={firstItem.suppliername} placeholder="Enter Please" onChange={handleChange}/>
              </td>
              <td>
                <input name="emailid" type="email" value={firstItem.emailid} placeholder="Enter Please" onChange={handleChange}/>
                {!isEmailValid && (
                  <span style={{ color: "red" }}>Invalid email address</span>
                )}
              </td>
              <td>
                <input name="phonenumber" value={firstItem.phonenumber} placeholder="Enter Please" onChange={handleChange}/>
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Address</td>
              
            </tr>

            <tr>
              <td>
                <input name="address" value={firstItem.address} placeholder="Enter Please" onChange={handleChange}/>
              </td>
              
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
           

           
          </table>
          <br />
          <hr />
          <div className="reset-addSupplier-button">
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Apply
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default Supplier;
